import { Link } from 'react-router-dom';
import MenuItem from './MenuItem';

const websiteSections = [
    // { title: 'Hero Section', path: '/dashboard/website/hero-section' },
    // { title: 'Welcome Message', path: '/dashboard/website/welcome-message' },
    { title: 'Banner', path: '/dashboard/website/banner' },
    { title: 'Footer', path: '/dashboard/website/footer' },
    { title: 'About Us', path: '/dashboard/website/about-us' },
    { title: 'Message From Management', path: '/dashboard/website/messageFromManagement' },
    { title: 'Product Category', path: '/dashboard/website/product-category' },
    { title: 'Product', path: '/dashboard/website/Product' },
    { title: 'Subscribers', path: '/dashboard/website/subscribers' },
    { title: 'Testimonial', path: '/dashboard/website/testimonial' },
    { title: 'Blog Category List', path: '/dashboard/website/blog-category' },
    { title: 'Blog List', path: '/dashboard/website/blogs' },
    { title: 'Brand', path: '/dashboard/website/brand' },
    { title: 'Partners Logo', path: '/dashboard/website/partners-logo' },
    { title: 'Corporate Logo', path: '/dashboard/website/corporate-logo' },
    { title: 'Contact Msg List', path: '/dashboard/website/contact-message' },
    { title: 'Photo Gallery', path: '/dashboard/website/photo-gallery' },
    { title: 'Why Choose Us', path: '/dashboard/website/why-choose-us' },
    { title: 'Stats Info', path: '/dashboard/website/stats' },
    { title: 'Working Process', path: '/dashboard/website/working-process' },
    { title: 'Pages', path: '/dashboard/website/pages' },
    // { title: 'Destination', path: '/dashboard/website/destination' },
    // { title: 'Tour Type', path: '/dashboard/website/tour-type' },
    // { title: 'Travel Category', path: '/dashboard/website/travel-category' },
    // { title: 'Package', path: '/dashboard/website/packages' },
    // { title: 'Booking', path: '/dashboard/website/booking' },
    // { title: 'Offer', path: '/dashboard/website/offer' },
    // { title: 'Visa', path: '/dashboard/website/visa' },
    // { title: 'Visa Type', path: '/dashboard/website/visa-type' },
    // { title: 'Subscribers', path: '/dashboard/website/subscribers' },
    // { title: 'Popup Forms', path: '/dashboard/website/popup-forms' },
    // { title: 'Contact Msg List', path: '/dashboard/website/contact-message' },
    // { title: 'Package Category', path: '/dashboard/website/package-category' },
    // { title: 'Our Service', path: '/dashboard/website/our-service' },
    // { title: 'Special Offer', path: '/dashboard/website/special-offer' },
    // { title: 'Stat Counter', path: '/dashboard/website/stat-counter' },
    // { title: 'Associates', path: '/dashboard/website/associates' },
    // { title: 'Certificate', path: '/dashboard/website/certificate' },
    // { title: 'Awards', path: '/dashboard/website/awards' },
    // { title: 'Video Gallery', path: '/dashboard/website/video-gallery' },
    // { title: 'Job List', path: '/dashboard/website/job-list' },
    // { title: 'Team Members List', path: '/dashboard/website/team-members' },
    // { title: 'CEO Message List', path: '/dashboard/website/ceo-message' },
    // { title: 'Mission, Vision & Motto', path: '/dashboard/website/mission-vision-motto' },
    // { title: 'Mosque List', path: '/dashboard/website/mosque-list' },
    // { title: 'Event Category', path: '/dashboard/website/event-category' },
    // { title: 'Event List', path: '/dashboard/website/events' },
    // { title: 'Facility', path: '/dashboard/website/facility' },
    // { title: 'Course Category ', path: '/dashboard/website/course-category' },
    // { title: 'Course List ', path: '/dashboard/website/courses' },
    // { title: 'Course Registration List ', path: '/dashboard/website/courses-registration' },
    // { title: 'Campeign Category ', path: '/dashboard/website/campeign-category' },
    // { title: 'Campeign List ', path: '/dashboard/website/campeigns' },
    // { title: 'Album List ', path: '/dashboard/website/album' },
    // { title: 'Surah List ', path: '/dashboard/website/audio-surah' },
];
const DashboardWebsiteSection = () => (
    <div>
        <MenuItem iconClass='bi bi-file-earmark-person' title='Websites'>
            {websiteSections.map((section) => (
                <li key={section.title}>
                    <Link to={section.path}>
                        <i className='bi bi-arrow-right-short' />
                        {section.title}
                    </Link>
                </li>
            ))}
        </MenuItem>
    </div>
);

export default DashboardWebsiteSection;
